import * as types from '../constants/actionTypes';
import { cloneDeep } from 'lodash';

import FeedbackInitialState from './feedbackInitialState';

export default function feedbackReducer(state = cloneDeep(FeedbackInitialState), action) {
  switch (action.type) {
    case types.CREATE_FEATURE_REQUEST_SUCCESS:
      return action.data.data;

    case types.CREATE_FEATURE_REQUEST_FAILURE:
      return state;

    default:
      return state;
  }
}
